export interface OrganizationSettingsProps {
	users: UserDisplay[];
	emailsReceivingReceipts: string[];
	onAddNewBillingContact: () => void;
	isLoadingBillingEmailsConfig: boolean;
	isLoadingOrganizationSettings: boolean;
	billingEmailsConfig: BillingEmailsConfig;
	organizationSettings: OrganizationSettings;
	getOrganizationSettings: () => Promise<void>;
	onSaveBillingEmailsConfig: (newConfig: BillingEmailsConfig) => void;
	onSaveOrganizationSettings: (newSettings: OrganizationSettings) => void;
}
export interface UserDisplay {
	id: number;
	role: string;
	name: string;
	email: string;
	avatar: string | null;
}
export interface OrganizationSettings {
	city: string;
	taxId: string;
	postalCode: string;
	addressLine1: string;
	addressLine2: string;
	countryOrRegion: string;
	organizationName: string;
}
export interface SmartUpgradeConfigurationProps {
	isSmartUpgradeOn: boolean;
	isSmartUpgradeChangeLoading: boolean;
	onToggleSmartUpgradeState: () => void;
}

export interface SettingsContext extends OrganizationSettingsProps, SmartUpgradeConfigurationProps {}

export enum BillingEmailsConfig {
	Invoices = 'invoices',
	Notifications = 'notifications',
}
